import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Box, Button, Stepper, Step, StepLabel } from '@mui/material';

import FASiteSelectionStep from './FASiteSelectionStep';
import FASoilTypeSelectionStep from './FASoilTypeSelectionStep';
import FAScenarioSelectionStep from "./FAScenarioSelectionStep";
import FASiteOptionsDataHelper from "../../data/FallowARM/FASiteOptionsDataHelper";
import FAScenarioOptionsDataHelper from "../../data/FallowARM/FAScenarioOptionsDataHelper";

const steps = ["Sites", "Soil Types", "Scenarios"]

class FAScenarioBuilder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalSteps: 3,
      activeStep: 0,
      // Currently Selected Site
      site: '',
      siteId: null,
      siteState: '',
      // Site specific information
      scenarioOptions: [],
      soilSettings: {},
      scenarios: [],
      soil_type: null,
      pawc: null,
      selectedSoil: null,
      // Other
      loadingState: 'none',
      error: '',
    };
  }

  handleSubmit = (event) => {
    event.preventDefault();
    this.props.submitScenarios(this.state.scenarios, [], true);
  }

  handleNext = (event) => {
    // Site selection step
    if (this.state.activeStep === 0) {
      if (this.state.site !== '') {
        this.setState({
          activeStep: this.state.activeStep + 1
        });
      }
    }
    // Soil selection step
    if (this.state.activeStep === 1) {
      if (this.state.selectedSoil) {
        this.setState({
          activeStep: this.state.activeStep + 1
        });
      }
    }
  }

  excludeOption = (fieldKey, removePAWCFromList = false) => {
    const excludeFields = ['soil', 'soilname', 'soil_type']
    if (!removePAWCFromList) {
      excludeFields.push('pawc');
    }
    const excludeIndex = excludeFields.indexOf(fieldKey.toLowerCase());
    return excludeIndex === -1 ? false : true;
  }

  loadOptions = (siteName) => {
    let self = this;
    FAScenarioOptionsDataHelper.scenarioOptionsFromAPI(siteName)
      .then((response) => {
        // console.log('API Response ', response);
        const apiOptions = response.data.options;
        // self.state.scenarioOptions = response.data.options;
        let finalOptions;
        if (self.state.selectedSoil.pawc) {
          finalOptions = apiOptions.filter(factor => !self.excludeOption(factor.key));
        }
        // let changedScenarioOptions = self.state.scenarioOptions;
        self.setState({
          //scenarioOptions: changedScenarioOptions,
          scenarioOptions: finalOptions,
          loadingState: 'success',
        });
      })
      .catch(function(error) {
        // console.log(error);
        self.setState({
          loadingState: 'error',
          error: error,
        });
      })
  }

  handlePrevious = (event) => {
    this.setState({
      activeStep: this.state.activeStep - 1
    });
  }

  // User has selected a site.
  handleSiteSelection = (locationObj) => {
    // Receives object:
    // {
    //    site: string (eg. "Dalby"),
    //    siteId: number,
    //    state: string (eg. "QLD"),
    //    lat: number,
    //    lng: number,
    // }

    // console.log(locationObj);
    const siteName = locationObj.site;

    this.setState({
      site: siteName,
      siteId: locationObj.siteId,
      siteState: locationObj.state,
      selectedSoil: null,
    });

  }

  handleSoilSelection = (soil) => {
    const siteName = this.state.site;

    // Now receives a soil list object:
    //  {
    //      soil: string,
    //      pawc: number,
    //      description: string,
    //      key: string,
    //      site: string,
    //      siteId: number,
    //  }
    
    this.setState({
      selectedSoil: {...soil}
    });


    this.loadOptions(siteName);
  }

  handleScenarioAddition = (selectedSimFactors) => {
    let scenariosToAdd;

    // let's make sure we take into account the overarching soil choices for this site
    scenariosToAdd = [
      {
        Site: this.state.site,
        // PAWC: this.state.soilSettings[site].pawc,
        PAWC: this.state.selectedSoil.pawc,
        ScenarioType: 'fallow',
        SoilName: this.state.selectedSoil.description,
      }
    ];

    // We need to calculate all the possible variations of scenarios to be added to our state.
    const filterFactors = this.state.scenarioOptions.filter((f) => f.filterOnly);
    const simFactors = this.state.scenarioOptions.filter((f) => !f.filterOnly);

    // Factorialise the simFactors but not the filterFactors.
    simFactors.forEach((factor) => {
      // console.log(factor.key);
      let updatedScenarios = [];
      let simValues = selectedSimFactors[factor.key];
      simValues.forEach((value) => {
        scenariosToAdd.forEach((scenario) => {
          let scenarioObj = {...scenario};
          scenarioObj[factor.key] = value;
          updatedScenarios.push(scenarioObj);
        })
      })
      scenariosToAdd = updatedScenarios;
    });

    const scenariosWithFilter = scenariosToAdd.map(scenario => {

      filterFactors.forEach((factor) => {
        if (selectedSimFactors.hasOwnProperty(factor.key)) {
          scenario[factor.key] = selectedSimFactors[factor.key];
        }
      });
      return scenario; 
    })

    let scenarioList = [
      ...this.state.scenarios,
      // ...scenariosToAdd
      ...scenariosWithFilter,
    ];

    // console.log('New scenario list', scenarioList);

    this.setState({
      scenarios: scenarioList
    });
  }

  handleScenarioDeletion = (scenarioIndex, allScenarios=false) => {
    if (!allScenarios) {
      this.state.scenarios.splice(scenarioIndex, 1);
    } else {
      this.state.scenarios = [];
    }

    let changedScenarioState = this.state.scenarios;

    this.setState({
      scenarios: changedScenarioState
    });
  }

  getStepContent(step) {
    switch(step) {
      case 0:
        return <FASiteSelectionStep
          handleSiteSelection={this.handleSiteSelection}
          selectedSite={this.state.site}
          selectedSiteId={this.state.siteId}
          singleSelectOnly={true}
        />
      case 1:
        return <FASoilTypeSelectionStep
          Site={this.state.site}
          SiteId={this.state.siteId}
          SelectedSoil={this.state.selectedSoil}
          handleSoilTypeSelection={this.handleSoilSelection}
        />
      case 2:
        return <FAScenarioSelectionStep
          Site={this.state.site}
          SiteId={this.state.siteId}
          SelectedSoil={this.state.selectedSoil}
          handleScenarioAddition={this.handleScenarioAddition}
          handleScenarioDeletion={this.handleScenarioDeletion}
          scenarios={this.state.scenarios}
        />
      default: 
        return null;  
    }
  }

  render() {
    return (
      <div>
        <Stepper activeStep={this.state.activeStep}>
          {steps.map((value) => {
            return (
              <Step key={value} completed={false}>
                <StepLabel>{value}</StepLabel>
              </Step>
            )
          })}
        </Stepper>
        {this.getStepContent(this.state.activeStep)}
        <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
          { this.state.activeStep !== 0 &&
            <Button disabled={this.state.activeStep === 0} onClick={this.handlePrevious}>Previous</Button>
          }
          <Box sx={{ flex: '1 1 auto' }} />
          { this.state.activeStep === this.state.totalSteps - 1 ?
            (
              <Button
                onClick={this.handleSubmit}
                disabled={
                  (this.state.activeStep === 2 && this.state.scenarios.length === 0)
                }>Submit</Button>
            ) :
            (
              <Button
                disabled={
                  (this.state.activeStep === 0 && this.state.site === '') ||
                  (this.state.activeStep === 1 && !this.state.selectedSoil)
                }
                onClick={this.handleNext}>
                Next
              </Button>
            )
          }
        </Box>
      </div>
    );
  }
}

FAScenarioBuilder.propTypes = {
  submitScenarios: PropTypes.func,
};

export default FAScenarioBuilder;
